'use strict';

var _jquery = require('./lib/jquery-3.3.1.min');

var _jquery2 = _interopRequireDefault(_jquery);

var _service = require('./service');

var _service2 = _interopRequireDefault(_service);

var _util = require('./util/util');

var _fb = require('./fb');

var fb = _interopRequireWildcard(_fb);

var _tips = require('./tips');

var _tips2 = _interopRequireDefault(_tips);

var _scroll = require('./util/scroll');

var _scroll2 = _interopRequireDefault(_scroll);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var exchange = {
    data: {
        characterDom: [],
        shift: 0,
        param: {},
        designatedCharacter: '雲塵, 花想容, 房芝, 甯佑, 儲陽, 景逸',
        characterName: ['雲塵', '花想容', '房芝', '甯佑', '儲陽', '景逸', '妳', '無赦', '商騁', '榮必圖', '鄭霄', '周瑾', '商馳', '神秘男子'],
        unCollected: [],
        characterInfo: {
            '景逸': {
                name: 'jingyi',
                id: 0
            },
            '雲塵': {
                name: 'yunchen',
                id: 1
            },
            '花想容': {
                name: 'hxr',
                id: 2
            },
            '房芝': {
                name: 'fangzhi',
                id: 3
            },
            '甯佑': {
                name: 'ningyou',
                id: 4
            },
            '儲陽': {
                name: 'chuyang',
                id: 5
            },
            '妳': {
                name: 'ni',
                id: 6
            },
            '無赦': {
                name: 'wusha',
                id: 7
            },
            '商騁': {
                name: 'shangcheng',
                id: 8
            },
            '榮必圖': {
                name: 'biyuan',
                id: 9
            },
            '鄭霄': {
                name: 'zhengxiao',
                id: 10
            },
            '周瑾': {
                name: 'zhoujin',
                id: 11
            },
            '商馳': {
                name: 'shangchi',
                id: 12
            },
            '神秘男子': {
                name: 'shenmi',
                id: 13
            }
        }
    },
    pcInit: function pcInit() {
        this.getLoginStatus();
        this.getCharacterDom();
        this.watchResize();
        this.getParam();
        this.bindEvent();
    },
    mobileInit: function mobileInit() {
        this.getLoginStatus();
        this.getCharacterDom();
        this.getParam();
        this.bindEvent('mobile');
    },
    bindEvent: function bindEvent(device) {
        var _this = this;

        (0, _jquery2["default"])('.do-exchange').click(function () {
            if (_this.data.hasLogin) {
                if (window.IS_RESERVED) {
                    if (_this.data.unCollected.length === 0) {
                        alert(_tips2["default"]['collectedAll']);
                        return;
                    }
                    if (_this.data.param.user_coins === 0) {
                        alert('今天抽獎次數已經用完，每日首次分享額外獲取一次抽獎機會喔~');
                        return;
                    }
                    _this.getGifts();
                } else {
                    alert('請預約后再來試試~');
                    var targetHeight = (0, _jquery2["default"])('.top').height();
                    var currentHeight = (0, _jquery2["default"])(window).scrollTop();
                    (0, _scroll2["default"])(currentHeight, targetHeight);
                }
            } else {
                alert(_tips2["default"][-1]);
                window.location.href = _util.config.url.login;
            }
        });
        (0, _jquery2["default"])('.exchange-popup-close').click(function () {
            _this.hideExchange();
        });
        (0, _jquery2["default"])('.share-friend').click(function () {
            window.open('https://www.facebook.com/gm99.bsj/', '_blank');
        });
        (0, _jquery2["default"])('.share-fb').click(function () {
            if (!_this.data.hasLogin) {
                alert(_tips2["default"][-1]);
                window.location.href = _util.config.url.login;
            } else {
                fb.share();
            }
        });
        (0, _jquery2["default"])('.btn-left').click(function () {
            if (_this.data.shift === 1) {
                (0, _jquery2["default"])('.btn-left').removeClass('active');
            }
            if (_this.data.shift < 1) {
                return;
            }
            var array = _this.data.characterDom;
            array.unshift(array.pop());
            _this.data.shift -= 1;
            (0, _jquery2["default"])('.j-character').html(array);
            (0, _jquery2["default"])('.btn-right').addClass('active');
            _this.addCollectedEvent();
        });
        (0, _jquery2["default"])('.btn-right').click(function () {
            var num = device === 'mobile' ? 2 : 1;
            if (_this.data.shift === num) {
                (0, _jquery2["default"])('.btn-right').removeClass('active');
            }
            if (_this.data.shift > num) {
                return;
            }
            var array = _this.data.characterDom;
            array.push(array.shift());
            _this.data.shift += 1;
            (0, _jquery2["default"])('.j-character').html(array);
            (0, _jquery2["default"])('.btn-left').addClass('active');
            _this.addCollectedEvent();
        });
        (0, _jquery2["default"])('.do-exchange-share').click(function () {
            var imgUrl = (0, _jquery2["default"])('.j-popup-character img').attr('src').slice(2);
            fb.init(imgUrl);
            fb.share();
        });
    },
    getLoginStatus: function getLoginStatus() {
        var _this2 = this;

        _service2["default"].getLoginStatus(function (res) {
            if (res.result === -1) {
                _this2.data.hasLogin = 0;
            } else {
                _this2.data.hasLogin = 1;
            }
        }, function (err) {
            console.log(err);
        });
    },
    addCollectedEvent: function addCollectedEvent() {
        var _this3 = this;

        var _loop = function _loop(key) {
            var name = _this3.data.characterInfo[key].name;
            (0, _jquery2["default"])('.' + name + '-collected').click(function () {
                _this3.popupExchange(name);
            });
        };

        for (var key in this.data.characterInfo) {
            _loop(key);
        }
    },
    getGifts: function getGifts() {
        var _this4 = this;

        var name = this.data.unCollected[(0, _util.random)(0, this.data.unCollected.length - 1)];
        var params = {
            ds_id: this.data.characterInfo[name].id
        };
        _service2["default"].getGifts(params, function (res) {
            _this4.popupExchange(_this4.data.characterInfo[name].name);
            var zijingCount = (res.data.user_all_coins - res.data.user_coins) * 50;
            (0, _jquery2["default"])('.j-zijing').html(zijingCount + '/700');
        }, function (err) {
            console.log(err);
        });
    },
    popupExchange: function popupExchange(name) {
        (0, _jquery2["default"])('.j-popup-character').html('<img src="./img/exchange/choujiang/c-' + name + '.png" alt="">');
        (0, _jquery2["default"])('html, body').addClass('unscroll');
        var $exchangePopup = (0, _jquery2["default"])('.exchange-popup');
        $exchangePopup.height((0, _jquery2["default"])(window).height());
        $exchangePopup.width((0, _jquery2["default"])(window).width());
        $exchangePopup.fadeIn();
    },
    hideExchange: function hideExchange() {
        this.getParam();
        (0, _jquery2["default"])('html, body').removeClass('unscroll');
        (0, _jquery2["default"])('.exchange-popup').fadeOut();
    },
    watchResize: function watchResize() {
        window.addEventListener('resize', function () {
            var $exchangePopup = (0, _jquery2["default"])('.exchange-popup');
            $exchangePopup.height((0, _jquery2["default"])(window).height());
            $exchangePopup.width((0, _jquery2["default"])(window).width());
        });
    },
    getParam: function getParam() {
        var _this5 = this;

        _service2["default"].getParam(function (res) {
            _this5.data.param = res.data;

            (0, _jquery2["default"])('.j-user-coins').html(res.data.user_coins);

            (0, _jquery2["default"])('.j-user-all-coins').html(res.data.user_all_coins);
            var collectedCount = 0;
            var ilength = res.data.ds_config.length;
            for (var i = 0; i < ilength; i++) {
                if (res.data.ds_config[i].TIMES === "1" && _this5.data.unCollected.indexOf(res.data.ds_config[i].NAME) === -1) {
                    _this5.data.unCollected.push(res.data.ds_config[i].NAME);

                    var zijingCount = (14 - _this5.data.unCollected.length) * 50;
                    (0, _jquery2["default"])('.j-zijing').html(zijingCount + '/700');
                }

                if (_this5.data.designatedCharacter.indexOf(res.data.ds_config[i].NAME) !== -1 && res.data.ds_config[i].TIMES !== "1") {
                    var _name = _this5.data.characterInfo[res.data.ds_config[i].NAME].name;
                    (0, _jquery2["default"])('.j-character .' + _name).addClass(_name + '-collected');
                    collectedCount += 1;
                }
            }
            (0, _jquery2["default"])('.j-collected-count').html(collectedCount);
            _this5.addCollectedEvent();
        }, function (err) {
            console.log(err);
        });
    },
    getCharacterDom: function getCharacterDom() {
        var dom = Array.prototype.slice.call((0, _jquery2["default"])('.j-character .item'));
        this.data.characterDom = dom;
    }
};
module.exports = exchange;


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/exchange.js
// module id = 106
// module chunks = 7 8